import React, { useState, useEffect } from "react";
import { Paper } from "@material-ui/core";

import moment from "moment";
import Chart from "./components/Chart";

const processData = (data, timeInterval = 15) => {
  let r = [];
  let lastReading = data[0];
  r.push(lastReading);
  let timeDiff = 0;

  data.forEach((item) => {
    timeDiff = moment(lastReading.date).diff(moment(item.date), "minutes");
    if (timeDiff > timeInterval) {
      lastReading = item;
      r.push(lastReading);
    }
  });
  r.push(data[data.length - 1]);
  return r;
};

function BatteryChart({ classes, data }) {
  const [filteredData, setFilteredData] = useState();
  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (!filteredData && data) {
      setFilteredData(processData(data, 30));
    }
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (filteredData) {
      console.log("filteredData: %o", filteredData);
      setSeries([
        {
          name: "Battery",
          data: filteredData.map((item) => {
            return {
              x: moment(item.date).utc(true).toDate().getTime(),
              y: item.value,
            };
          }),
        },
      ]);
    }
    // eslint-disable-next-line
  }, [filteredData]);

  const options = {
    tooltip: {
      x: {
        show: true,
        format: "HH:mm",
      },
    },
    title: {
      text: "Last 24h readings",
      align: "left",
    },
    xaxis: {
      type: "datetime",
      title: {
        text: "Time",
      },
      min: new Date().getTime() - 1 * 24 * 60 * 60 * 1000,
      max: new Date().getTime(),
    },
    yaxis: {
      title: {
        text: "Battery",
      },
      min: 0,
      max: 100,
    },
  };

  return (
    <Paper style={{ padding: 20 }}>
      <Chart options={options} series={series} type="line" height={350} />
    </Paper>
  );
}

export default BatteryChart;
